// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-heading[data-v-9db38834] {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-collapsible-item.vue","webpack://./np-collapsible-item.vue"],"names":[],"mappings":"AACI;EACI,eAAA;ACAR","sourcesContent":["\n    .panel-heading {\n        cursor: pointer;\n    }\n",".panel-heading {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
